/**
 * Environment configuration for React frontend.
 *
 * This configuration exports environment variables that are used throughout the frontend.
 * Values are loaded from import.meta.env with empty string defaults if not specified.
 *
 * @property {string} VITE_PROJECT_NAME - The project name
 * @property {string} VITE_PROJECT_VERSION - The project version
 * @property {string} VITE_ENV - The current environment name
 */
export const environmentConfig = {
  // Environment variables
  PROJECT_NAME: import.meta.env.VITE_PROJECT_NAME || '',
  PROJECT_VERSION: import.meta.env.VITE_PROJECT_VERSION || '',
  ENV: import.meta.env.VITE_ENV || 'production',
};
